import {
  putCustomMarkApiRequest,
  putCustomMarkBasicApiRequest,
} from '@/services/api/custom-marks-api';

export class AddMarksApi {
  loading: boolean = false;
  error: boolean = false;

  put(payload: Bemob.CustomMark) {
    this.loading = true;

    return putCustomMarkApiRequest(payload).then((response) => {
      this.loading = false;
      return response;
    }).finally(() => {
      this.loading = false;
    });
  }

  putBasic(path: string, payload: Bemob.CustomMarkBase) {
    this.loading = true;

    return putCustomMarkBasicApiRequest(path, payload).then((response) => {
      this.loading = false;
      return response;
    }).finally(() => {
      this.loading = false;
    });
  }
}

export default new AddMarksApi();
